import { render, staticRenderFns } from "./ModalAddExtraInfo.vue?vue&type=template&id=1350fe2f"
import script from "./ModalAddExtraInfo.vue?vue&type=script&lang=js"
export * from "./ModalAddExtraInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports